import styled from "styled-components";

interface IFilter {
  handlePageChange: (newPerPage: number) => void; // Recebe o valor selecionado
  allFilter: number;
}
export default function FilterNumber({
  handlePageChange,
  allFilter
}: IFilter) {

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = parseInt(event.target.value, 10); // Obtém o valor selecionado
    handlePageChange(selectedValue); // Chama a função do pai passando o novo valor
  };

  return (
    <Select id="selection" name="Filtro" onChange={handleChange}>
      {Array.from(
        { length: Math.floor(Math.min(allFilter, 100) / 10) },
        (_, index) => {
          const value = (index + 1) * 10;
          return (
            <option key={value} value={value}>
              {value}
            </option>
          );
        }
      )}

      {allFilter > 100 || allFilter % 10 !== 0 ? (
        <option key={allFilter} value={allFilter}>
          {allFilter}
        </option>
      ) : null}
    </Select>
  );
}

const Select = styled.select`
  background-color: ${(props) => props.theme.colors.gray.gray_50};
  border-radius: 30px;
  padding: 5px 10px;

  &:hover {
    background-color: ${(props) => props.theme.colors.gray.gray_100};
  }
`;
